import React from 'react';
import "./Home.css";
import Homeimage from '../images/png/image 5.png'
const Home=()=> {
  return (
    
        <div className='container2'>
            <div className='homeimage'>
                <h1></h1>
                <img src={Homeimage} alt="Home image not availble"/>
                
            </div>
            <div className='subContainer'>
                <div className='india'>
                    <h1>India's Leading Creative Platform</h1>
                    <p>Experience hassle free booking.Trusted by 25OO+ Customers </p>
                </div>
                <div className='searchbar'>
                    <input type="text" value='Search service, blog and many more..'/>
                    <button type="submit">Search</button>
                    
                </div>
                
            </div>
            
        </div>
  )
}
export {Home}
